module.exports = __webpack_public_path__ + "img/senias-datensatzdetail-2.4ccbdf31.png";